// get endpoint url from meta tag
var aws_api_endpoint_url = $('meta[name="aws-api-endpoint-url"]').attr('content');

// US/Canadian postal code regex
const postalCodeRegex = /^(?:\d{5}|[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d)$/i;

function decodeJWT(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
}

const errorMessageBuilder = error => {
  const gpiError = createGPIError({
    rawError: error,
    code: 'tokenization_error',
    clientType: 'TOKENIZER',
  });
  return gpiError.message;
};

class GpiCardFormEventEmitter extends EventEmitter {
  constructor(configuration, formConfig) {
    super();
    this.configuration = configuration;
    this.formConfig = formConfig;
    this.resetForm = () => this;
  }

  initialize() {
    GlobalPayments.on('error', error => this.emit('error', error));
    GlobalPayments.configure(this.configuration);
    const setupForm = () => {
      const uiForm = GlobalPayments.ui.form(this.formConfig);
      uiForm.on('click', () => this.emit('submit'));
      uiForm.on('token-success', response => this.emit('token-success', response.temporary_token));
      // uiForm.on('token-error', response => this.emit('error', errorMessageBuilder(response)));
      // uiForm.on('token-error', response => this.emit('error', 'asdfasdfasdfasdf'));
      uiForm.on('token-error', response => this.emit('error', createGPIError({
        rawError: response,
        code: 'tokenization_error',
        clientType: 'TOKENIZER',
      }).message ?? 'An error occurred while adding the card. Please try again later or use a different payment method.'));

      this.resetForm = () => {
        uiForm.dispose();
        setupForm();
        return this;
      };
    };

    setupForm();

    return this;
  }
}

class GpiBankAccountEventEmitter extends EventEmitter {
  constructor(formSelector) {
    super();

    this.formSelector = formSelector;
  }
  initialize() {
    $(this.formSelector).on('submit', event => {
      event.preventDefault();

      this.emit('submit');
    });

    return this;
  }

  resetForm() {
    $(`${this.formSelector} input, ${this.formSelector} select`).val('');
  }
}


class GpiCardFormValidator extends EventEmitter {
  constructor({ nonce, street, zip }) {
    super();
    this.nonce = nonce;
    this.street = street;
    this.zip = zip;
  }

  validate(accountFormEventEmitter) {
    const onTokenSuccess = temporaryToken => {
      if (!this.street.val()?.length) {
        return onError('Please Enter a Street Address');
      }

      if (!postalCodeRegex.test(this.zip.val())) {
        return onError('Please Enter a Valid Zip Code');
      }

      this.saveToken(temporaryToken, done);
    };

    const onError = err => {
      console.log('GpiCardFormValidator: onError called with:', err);
      this.emit('error', err);
      done();
    };

    const done = () => {
      this.emit('done');

      accountFormEventEmitter
        .off('token-success', onTokenSuccess)
        .off('error', onError);
    };

    accountFormEventEmitter
      .on('token-success', onTokenSuccess)
      .on('error', onError);

    return this;
  }

  saveToken(token, done) {
    sendAjaxUserMicro('add-card', {
      street: this.street.val(),
      zip: this.zip.val(),
      token
    })
      .then(result => {
        if (result.status === 'success') {
          this.emit('success', result.message);
        } else {
          console.log('GpiCardFormValidator: saveToken error with result:', result);
          this.emit('error', result.message);
        }
        done();
      })
      .catch(err => {
        console.log('GpiCardFormValidator: saveToken caught error:', err);
        this.emit('error', err.message);
        done();
      });

    return this;
  }
}

class GpiBankAccountFormValidator extends EventEmitter {
  constructor({ accountNumber, routingNumber, accountType, firstName, lastName, businessName, nonce }) {
    super();

    this.accountNumber = accountNumber;
    this.routingNumber = routingNumber;
    this.accountType = accountType;
    this.firstName = firstName;
    this.lastName = lastName;
    this.businessName = businessName;
    this.nonce = nonce;
    this.paymentProviderId = 1;
  }

  async validate() {
    const isBusinessAccount = this.businessName.is(':visible');
    let name = null;

    if (!this.accountNumber.val()) {
      return this.emitError('Please enter an account number.');
    }

    if (!this.routingNumber.val()) {
      return this.emitError('Please enter your bank\'s routing number.');
    }

    if (!this.accountType.val()) {
      return this.emitError('Please select an account type.');
    }

    if (isBusinessAccount) {
      if (!this.businessName.val()) {
        return this.emitError('Please enter the business name');
      }

      name = {
        business_name: this.businessName.val()
      };
    } else {
      if (!this.firstName.val()) {
        return this.emitError('Please enter your first name.');
      }

      if (!this.lastName.val()) {
        return this.emitError('Please enter your last name.');
      }

      name = {
        first_name: this.firstName.val(),
        last_name: this.lastName.val()
      };
    }

    try {
      const result = await sendAjaxUserMicro('add-bank-account', {
        accountNumber: this.accountNumber.val(),
        routingNumber: this.routingNumber.val(),
        accountType: this.accountType.val(),
        name,
        paymentProviderId: this.paymentProviderId,
      });

      if (result.status !== 'success') {
        return this.emitError(result.message);
      }

      this.emit('success', result.message).emit('done');
    } catch (err) {
      this.emitError(err.message);
    }

    return this;
  }

  emitError(message) {
    return this.emit('error', message).emit('done');
  }
}

let GPIForm = {
  fields: {
    'card-number': {
      target: '#card-number-gpi',
      placeholder: '1234 1234 1234 1234'
    },
    'card-expiration': {
      target: '#card-expiration-gpi',
      placeholder: 'MM / YYYY'
    },
    'card-cvv': {
      target: '#card-cvv-gpi',
      placeholder: 'CVC'
    },
    submit: {
      target: '#submit-gpi',
      text: 'Add New Card'
    }
  },
  styles: {
    'input': {
      "font-size": '16px',
      "line-height": '42px',
      'background-position': '9px center',
      'background-repeat': 'no-repeat',
      'background-size': '18px 18px',
      'display': 'block',
      'height': '44px',
      'padding': '0 1em',
      'background-color': '#FFFFFF',
      'border': '1px solid #000000',
      'border-radius': '3px',
      'line-height': '44px',
    },
    'input.card-number': {
      'padding-left': '36px',
      'background-image': "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><path d=\"M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z\"/></svg>')",
    },
    'input.card-expiration': {
      'padding-left': '36px',
      'background-image': "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path d=\"M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z\"/></svg>')",
    },
    'button.submit': {
      'display': 'inline-block',
      'width': 'auto',
      'height': '44px',
      'padding': '0 1.5rem',
      'border': '1px solid #239729',
      'border-radius': '3px',
      'line-height': '42px',
      'color': '#FFFFFF',
      'cursor': 'pointer',
      'transition': 'all 0.25s ease-in-out',
      'background-color': '#000000',
      'border-color': '#000000',
      "font-family": 'sans-serif',
      'font-weight': '700',
      'font-size': '16px'
    },
    'button.submit:hover': {
      'background-color': '#00C94B',
      'border-color': '#009738'
    }
  }
}

const checkoutValidationOptions = {
  errorElement: 'span',
  errorClass: 'form-field-error',
  validClass: 'form-field-valid',
  errorPlacement: function (error, element) {
    error.appendTo(element.parents('.form-field'));
  },
  highlight: function (element, errorClass, validClass) {
    $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
  },
  ignore: '.ignore',
  rules: {
    'quantity': {
      required: true,
      number: true,
      min: '1'
    },
    'first-name': {
      required: true,
      minlength: 2
    },
    'last-name': {
      required: true,
      minlength: 2
    },
    'email': {
      required: true,
      email: true
    },
    'phone-number': {
      required: true,
      phoneUS: true
    },
    'street-address': {
      required: true,
      minlength: 2
    },
    'city': {
      required: true,
      minlength: 2
    },
    'state': {
      required: true
    },
    'zip-code': {
      required: true,
      zipcodeUS: true
    },
    'license-plates': {
      required: true
    },
    'new-license-plate': {
      required: {
        depends: function () {
          var licensePlatesValue = $('input[name="license-plates"]:checked').val();
          if (licensePlatesValue == 'new') {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    'license-plate': {
      required: true
    },
    'employer': {
      required: true
    },
    'unit-number': {
      required: true
    },
    'gpi-street-address': {
      required: {
        depends: function () {
          return $('gpi-credit-card-new').prop('checked');
        }
      },
      minlength: 2,
    },
    'gpi-zip-code': {
      required: {
        depends: function () {
          return $('gpi-credit-card-new').prop('checked');
        }
      },
      zipcodeUS: true,
    },
    'facility': {
      required: true
    },
    'vehicle-year': {
      required: true
    },
    'vehicle-make': {
      required: true
    },
    'vehicle-model': {
      required: true
    },
    'service-type': {
      required: true
    },
    'date-of-service': {
      required: true
    },
    'time-of-day': {
      required: true
    }
  },
  messages: {
    'quantity': {
      required: 'Please enter a quantity.',
      number: 'Quantity must be a number.',
      min: 'Quantity must be at least 1.'
    },
    'first-name': {
      required: 'Please enter your first name.',
      minlength: 'Your first name must be at least 2 characters long.'
    },
    'last-name': {
      required: 'Please enter your last name.',
      minlength: 'Your last name must be at least 2 characters long.'
    },
    'email': {
      required: 'Please enter your email address.',
      email: 'Please enter a valid email address.'
    },
    'phone-number': {
      required: 'Please enter your phone number.',
      phoneUS: 'Please enter a valid phone number.'
    },
    'street-address': {
      required: 'Please enter your street address',
      minlength: 'Please enter a valid street address.'
    },
    'city': {
      required: 'Please enter your city.',
      minlength: 'Please enter a valid city name.'
    },
    'state': {
      required: 'Please enter your state.'
    },
    'zip-code': {
      required: 'Please enter your zip code.',
      zipcodeUS: 'Please enter a valid zip code.'
    },
    'license-plates': {
      required: 'Please choose a license plate.'
    },
    'license-plate': {
      required: 'Please enter your license plate.'
    },
    'new-license-plate': {
      required: 'Please enter your license plate.'
    },
    'employer': {
      required: 'Please enter your company name.'
    },
    'unit-number': {
      required: 'Please enter your unit number.'
    },
    'gpi-street-address': {
      required: `Please enter the cardholder's street address`,
      minlength: 'Please enter a valid street address'
    },
    'gpi-zip-code': {
      required: `Please enter the cardholder's zip code`,
      zipcodeUS: 'Please enter a valid zip code'
    },
    'facility': {
      required: 'Please choose a facility.'
    },
    'vehicle-year': {
      required: 'Please choose a vehicle year.'
    },
    'vehicle-make': {
      required: 'Please enter the make of your vehicle.'
    },
    'vehicle-model': {
      required: 'Please enter the model of your vehicle.'
    },
    'service-type': {
      required: 'Please choose a service type.'
    },
    'date-of-service': {
      required: 'Please choose a date for your service.'
    },
    'time-of-day': {
      required: 'Please choose a time for your service.'
    }
  },
}

const submitForm = function (creditCard, gpiCardStreetAddress = null, gpiCardZip = null, recaptcha_token) {
  // get reCAPTCHA site key from script URL
  const recaptcha_url = new URL($('#recaptcha-js').attr('src'));
  const recaptcha_site_key = recaptcha_url.searchParams.get('render');
  // let's get a reCAPTCHA token and try to checkout...
  grecaptcha.ready(function() {
    grecaptcha.execute(recaptcha_site_key, { action: 'legacy_checkout' }).then(function(token) {
      let userId = $('#user-id').val();
      let firstName = $('#first-name').val();
      let lastName = $('#last-name').val();
      let email = $('#email').val();
      let phoneNumber = $('#phone-number').val();
      let streetAddress = $('#street-address').val();
      let city = $('#city').val();
      let state = $('#state').val();
      let zipCode = $('#zip-code').val();
      let promoCode = $('#promo-code').val();
      let price = $('#price').val();
      let facilityId = $('#facility-id').val();
      let parkingType = $('#parking-type').val();
      let nonce = $('#chirp-checkout-nonce').val();
      let recaptcha_token = token;
      let saveCardToAccount = $('#card-save-to-account').is(':checked') ? true : false;
      let isCarWash = false;
      if (parkingType === 'coupon' && $('#car-wash').length > 0 && $('#car-wash').val() === 'true') {
        isCarWash = true;
      }

      // chosen license plate
      var licensePlate;
      // array of license plates to save
      var licensePlates = [];
      // if radio buttons or single license plate fields exist (this facility requires plates)
      if ($('input[name="license-plates"]').length || $('#license-plate').length) {
        // if user already has saved plates
        if ($('input[name="license-plates"]').length) {
          // get selected license plate
          var licensePlate = $('input[name="license-plates"]:checked').val();
          // if 'new' is chosen, get the value from the #license-plate field
          if (licensePlate == 'new') {
            var licensePlate = $('#new-license-plate').val();
          }
          // push all license plates into array to save to account
          $('input[name="license-plates"]').each(function () {
            var fieldValue = $(this).val();
            if (fieldValue == 'new') {
              if ($(this).is(':checked')) {
                if ($('#new-license-plate').val().length > 0) {
                  var newFieldValue = $('#new-license-plate').val();
                  licensePlates.push(newFieldValue);
                }
              }
            } else {
              licensePlates.push(fieldValue);
            }
          });
          // if user has no saved plates
        } else {
          var licensePlate = $('#license-plate').val();
          licensePlates.push(licensePlate);
        }
      }

      let hourlyFields = parkingType == 'hourly' ? selectHourlyFields() : {};
      let monthlyFields = parkingType == 'monthly' ? selectMonthlyFields() : {};
      let couponFields = parkingType == 'coupon' && isCarWash === false ? selectCouponFields() : {};
      let carWashFields = parkingType == 'coupon' && isCarWash === true ? selectCarWashFields() : {};

      let checkoutArgs = {
        action: 'chirp_checkout',
        parkingType,
        userId,
        firstName,
        lastName,
        email,
        phoneNumber,
        streetAddress,
        city,
        state,
        zipCode,
        licensePlate,
        licensePlates,
        promoCode,
        price,
        facilityId,
        creditCard,
        saveCardToAccount,
        nonce,
        gpiCardStreetAddress,
        gpiCardZip,
        recaptcha_token,
        isCarWash
      }

      Object.assign(checkoutArgs, hourlyFields);
      Object.assign(checkoutArgs, monthlyFields);
      Object.assign(checkoutArgs, couponFields);
      Object.assign(checkoutArgs, carWashFields);

      console.log(checkoutArgs);

      // wrap everything up into an object
      var metadata = {};
      if (firstName !== undefined) {
        metadata['firstName'] = firstName;
      }
      if (lastName !== undefined) {
        metadata['lastName'] = lastName;
      }
      if (phoneNumber !== undefined) {
        metadata['phoneNumber'] = phoneNumber;
      }
      if (streetAddress !== undefined) {
        metadata['street'] = streetAddress;
      }
      if (city !== undefined) {
        metadata['city'] = city;
      }
      if (state !== undefined) {
        metadata['state'] = state;
      }
      if (zipCode !== undefined) {
        metadata['zip'] = zipCode;
      }
      if (licensePlate !== undefined) {
        metadata['licensePlates'] = [licensePlate];
      }
      if (licensePlates.length > 0) {
        metadata['licensePlates'] = licensePlates;
      }
      // convert object to JSON
      metadata = JSON.stringify(metadata);
      // console.log(metadata);

      // get AWS Cognito ID Token from cookie
      var id_token = getCookie('aws_cognito_id_token');
      if (id_token.length) {
        // update user metadata
        $.ajax({
          type: 'post',
          url: aws_api_endpoint_url +'update-user-metadata',
          headers: {
            'Authorization': id_token
          },
          data: metadata,
          contentType: 'application/json',
          success: function(results) {
            console.log('Profile updated!', results);
            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: checkoutArgs,
              timeout: 100000,
              success: function (results) {
                console.log('success');
                console.log(results);
                var results = JSON.parse(results);
                console.log(results);
                var body = JSON.parse(results.body);
                var transactionId = body._id;
                console.log('transactionId:', transactionId);
                // refresh tokens after successful checkout
                $.ajax({
                  type: 'post',
                  url: '/wp-admin/admin-ajax.php',
                  data: {
                    action: 'aws_cognito_refresh_token'
                  },
                  success: function(results) {
                    var results = JSON.parse(results);
                    if (results.status === 'success') {
                      console.log('Tokens refreshed!', results);
                      window.location.href = '/account/receipt/?transaction=' + transactionId + '&new=true';
                    } else if (results.status === 'error') {
                      console.log('Tokens not refreshed?!', results);
                      window.location.href = '/account/receipt/?transaction=' + transactionId + '&new=true';
                    }
                  },
                  error: function(results) {
                    console.log('Tokens refresh failed?', results);
                    window.location.href = '/account/receipt/?transaction=' + transactionId + '&new=true';
                  }
                });
              },
              error: function (results) {
                console.log('error');
                console.log(results);
                var responseJSON = results.responseText ?? results.statusText;
                console.log(responseJSON);
                $('#checkout-submit').prop('disabled', false);
                $('#submit-gpi').show();
                $('.free-spinner').prop('disabled', false);
                $('.button-spinner').prop('disabled', false);
                var responseBody = results.status == 500 ? responseJSON.message : responseJSON.body ? responseJSON.body : responseJSON;
                var errorMessage = responseBody || 'There is an issue processing your payment. Please review the information entered, and try again.'
                $('#payment-details .form-card-message').addClass('form-card-message-error').text(errorMessage);
              }
            });
          },
          error: function(results) {
            console.log('Profile not updated?', results);
          }
        });
      }
    });
  });

}

const selectHourlyFields = function () {
  let startDate = $('#start-date').val();
  let startTime = $('#start-time').val();
  let endDate = $('#end-date').val();
  let endTime = $('#end-time').val();
  let timezone = $('#timezone').val();

  //DEV NOTE: Processing all time as UTC going forward. Fixes so far every browser based conversion issues
  //we have been facing
  let startDateTime = moment.tz(startDate + ' ' + startTime, 'YYYY-MM-DD HH:mm', "UTC").toISOString();
  let endDateTime = moment.tz(endDate + ' ' + endTime, 'YYYY-MM-DD HH:mm', "UTC").toISOString();
  return { startDateTime, endDateTime };
}

const selectMonthlyFields = function () {
  let monthlyOptions = $('input[type="radio"][name="monthly-options"]:checked').val();
  let startDate = $('#start-date').val();
  let startTime = $('#start-time').val();
  let quantity = $('#quantity').val();
  let timezone = $('#timezone').val();

  let startDateTime;
  if (startDate && startTime) {
    startDateTime = moment.tz(startDate + ' ' + startTime, 'YYYY-MM-DD HH:mm', timezone).toISOString();
  } else {
    startDateTime = moment.tz($('#start-date-monthly').val(), 'YYYY-MM-DD HH:mm', timezone).toISOString();
  }

  console.log("Select Monthly Fields :" + startDateTime);

  // custom questions
  let whyPurchaseMonthly = $('input[name="why-purchase-monthly"]:checked').val();
  let employer = $('#employer').val();
  let unitNumber = $('#unit-number').val();

  return { whyPurchaseMonthly, employer, unitNumber, startDateTime, quantity, monthlyOptions };
}

const selectCouponFields = function () {
  let couponOptions = $('input[type="radio"][name="coupon-options"]:checked').val();
  let quantity = $('#quantity').val();

  // custom questions
  let whyPurchaseCoupons = $('input[name="why-purchase-coupons"]:checked').val();
  let unitNumber = $('#unit-number').val();

  return { couponOptions, quantity, whyPurchaseCoupons, unitNumber };
}

const selectCarWashFields = function () {

  let facility = $('#facility').val();
  let vehicleYear = $('#vehicle-year').val();
  let vehicleMake = $('#vehicle-make').val();
  let vehicleModel = $('#vehicle-model').val();
  let couponOptions = $('input[type="radio"][name="coupon-options"]:checked').val();
  let quantity = $('#quantity').val();
  let addOnServices = [];
  let services = $('input[name="add-on-services"]');
  if (services.length > 0) {
    $(services).each(function(index, service) {
      if ($(service).is(':checked')) {
        let addOnService = {};
        addOnService['title'] = $(service).attr('data-title');
        addOnService['price'] = parseFloat($(service).attr('data-price'));
        addOnService['price_in_pennies'] = parseInt($(service).attr('data-price-pennies'));
        addOnServices.push(addOnService);
      }
    });
    addOnServices = JSON.stringify(addOnServices);
  }
  let dateOfService = $('#date-of-service').val();
  let timeOfDay = $('#time-of-day').val();
  let additionalInformation = $('#additional-information').val();

  return { facility, vehicleYear, vehicleMake, vehicleModel, couponOptions, quantity, addOnServices, dateOfService, timeOfDay, additionalInformation };
}

const checkoutValidationOptionsWithHandler = {
  ...checkoutValidationOptions,
  submitHandler: function(form) {
    var creditCard = $('input[name="gpi-credit-cards"]:checked').val();
    console.log('paying with ' + creditCard);
    $('.button-spinner', form).prop('disabled', true);
    submitForm(creditCard);
  }
}

function toggleBusiness(paymentProvider) {
  const parentFormSelector = `#add-${paymentProvider}-bank-account`;
  const personalDetails = document.querySelector(`${parentFormSelector} #personal-account-form-field`);
  const businessName = document.querySelector(`${parentFormSelector} #business-account-form-field`);
  const businessAccountButton = document.querySelector(`${parentFormSelector} #business-account`);
  const individualAccountButton = document.querySelector(`${parentFormSelector} #individual-account`);

  personalDetails.style.display = "none"
  businessAccountButton.style.display = "none"
  businessName.style.display = "block"
  individualAccountButton.style.display = "block"
}

function toggleIndividual(paymentProvider) {
  const parentFormSelector = `#add-${paymentProvider}-bank-account`;
  const personalDetails = document.querySelector(`${parentFormSelector} #personal-account-form-field`);
  const businessName = document.querySelector(`${parentFormSelector} #business-account-form-field`);
  const businessAccountButton = document.querySelector(`${parentFormSelector} #business-account`);
  const individualAccountButton = document.querySelector(`${parentFormSelector} #individual-account`);

  personalDetails.style.display = "flex"
  businessAccountButton.style.display = "block"
  businessName.style.display = "none"
  individualAccountButton.style.display = "none"
}

$(document).ready(async function () {
  const isPaymentMethodsPage = isAccountPage('payment');
  const isOneTimePaymentPage = isAccountPage('monthly-one-time-payment');
  const isRecurringPaymentPage = isAccountPage('monthly-recurring-payments');
  const isCheckoutPage = (
    bodyHasClass('single-facilities') ||
    bodyHasClass('atl2-single-facilities') ||
    bodyHasClass('page-template-page-sf-home-checkout') ||
    bodyHasClass('page-template-page-sky55-home') ||
    bodyHasClass('page-template-page-beacon-checkout') ||
    bodyHasClass('page-template-page-bloc-checkout') ||
    bodyHasClass('page-template-page-peak-car-wash')
  );
  const isMobilePage = bodyHasClass('page-template-page-mobile-payment-form');
  const gpiProviderName = 'GPI';

  let gpiApiKey = $('meta[name="gpi-tokenization-api-key"]').attr('content');
  let gpiEnvironment = $('meta[name="gpi-environment"]').attr('content');

  if (isCheckoutPage) {
    GlobalPayments.configure({
      'X-GP-Api-Key': gpiApiKey,
      'X-GP-Environment': gpiEnvironment,
      'enableAutocomplete': true
    });

    GPIForm.fields.submit.text = 'Checkout'
    let cardForm = GlobalPayments.ui.form(GPIForm);

    let validator = $('#checkout').validate(checkoutValidationOptionsWithHandler);

    $('input[name="gpi-credit-cards"]').change(function () {
      if (this.value === 'new') {
        // $('#new-gpi-credit-card-fields').show();
        $('#new-gpi-credit-card-fields').addClass('form-field-group-accordion-open');
        $('#gpi-checkout-submit').hide();
        validator.destroy();
        $('#checkout').validate(checkoutValidationOptions);
      } else {
        // $('#new-gpi-credit-card-fields').hide();
        $('#new-gpi-credit-card-fields').removeClass('form-field-group-accordion-open');
        $('#gpi-checkout-submit').show();
        validator.destroy();
        // When using a saved credit card, form submission occurs outside of GPI PayFields
        $('#checkout').validate(checkoutValidationOptionsWithHandler);
      }
    });

    GlobalPayments.on('error', error => {
      $('#submit-gpi').show();
      $('#payment-details .form-card-message').addClass('form-card-message-error').text(error);
    });

    cardForm.on('token-error', response => {
      $('#submit-gpi').show();
      $('#payment-details .form-card-message').addClass('form-card-message-error').text(errorMessageBuilder(response));
    });

    cardForm.on('token-success', response => {
      $('.free-spinner').prop('disabled', true);
      console.log('Success!');
      console.log(response);

      let formValid = validator.form();
      if (formValid) {
        let gpiCardStreetAddress = $('#gpi-street-address').val();
        let gpiCardZip = $('#gpi-zip-code').val();
        submitForm(response.temporary_token, gpiCardStreetAddress, gpiCardZip);
      } else {
        $('.free-spinner').prop('disabled', false);
        $('#submit-gpi').show();
      }
    });

    cardForm.on('click', () => {
      $('#submit-gpi').hide();
    });
  }

  if (isPaymentMethodsPage) {
    const accountForms = await setupAccountPaymentForms(gpiProviderName, makeCardLoader('checkbox'), makeBankAccountLoader('checkbox'));
    setupAccountDeletionForms();
    accountForms.card.on('success', () => $('.manage-credit-cards').attr('style', ''));
    accountForms.bankAccount.on('success', () => $('.manage-bank-accounts').attr('style', ''));
  }

  if (isOneTimePaymentPage || isRecurringPaymentPage) {
    const checkoutButton = $('button.payment-checkout');
    const accountForms = await setupAccountPaymentForms(gpiProviderName, makeCardLoader('radio'), makeBankAccountLoader('radio'));

    accountForms.bankAccount
      .on('submit', () => checkoutButton.attr('disabled', true))
      .on('success', () => {
        $('#new-bank-account-fields').hide();
        $('.form-card-message', this).empty();
      })
      .on('done', () => checkoutButton.attr('disabled', false));

    accountForms.card
      .on('submit', () => checkoutButton.attr('disabled', true))
      .on('success', () => {
        $('#new-credit-card-fields').hide();
        $('.form-card-message', this).empty();
      })
      .on('done', () => {
        $('#gpi-street-address').empty();
        $('#gpi-zip-code').empty();
        checkoutButton.attr('disabled', false);
  });
  }

  if (isMobilePage) {
    let urlParams = new URLSearchParams(window.location.search);
    let allowTemporaryCard = urlParams.get('allowTemporaryCard');

    if (allowTemporaryCard === 'false') {
      $('.checkboxes-group').css('display', 'none');
    }

    GlobalPayments.configure({
      'X-GP-Api-Key': gpiApiKey,
      'X-GP-Environment': gpiEnvironment,
      'enableAutocomplete': true
    });

    let cardForm = GlobalPayments.ui.form(GPIForm);

    GlobalPayments.on('error', error => {
      $('#add-gpi-payment .form-card-message').addClass('form-card-message-error').text(error);
    });

    cardForm.on('token-success', response => {
      $('.free-spinner').prop('disabled', true);

      let cardToken = response.temporary_token;
      let street = $('#gpi-street-address').val();
      let zip = $('#gpi-zip-code').val();
      let saveCardToAccount = $('#gpi-save-card').is(':checked');

      setTimeout(function () {
        const params = new URLSearchParams();
        params.append('token', cardToken);
        params.append('street', street);
        params.append('zip', zip);
        params.append('saveCardToAccount', saveCardToAccount);

        window.location.href = window.location.origin + '/mobile-payment-complete?' + params.toString();
      }, 1000);
    });

    cardForm.on('token-error', response => {
      $('#add-gpi-payment .form-card-message').addClass('form-card-message-error').text(errorMessageBuilder(response));
    });
  }
});

function setupAccountDeletionForms() {
  setupCardDeletionForm();
  setupBankAccountDeletionForm();
}

function setupAccountDeletionForm(formSelector, nonceSelector, ajaxCall) {
  // GraphQL Credentials
  var graphQLToken = $('#token').attr('value');
  var graphQLAuth = 'Bearer ' + graphQLToken;
  var graphQLNonce = $('#chirp-monthly-nonce').val();

  $(formSelector).submit(async function (e) {
    e.preventDefault();

    console.log('formSelector:', formSelector);

    $('.button-spinner', this).prop('disabled', true);
    let nonce = $(nonceSelector).val();

    let tokenIds = [];
    $('input[type="checkbox"]:checked', this).each(function () {
      let thisTokenId = $(this).val();
      tokenIds.push(thisTokenId);
    });

    if (tokenIds.length > 0) {
      try {
        const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
        const listSubsResponse = await sendAjax('chirp_graphql', {
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: 'query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, paymentMethod { token }, auto_pay } }',
          graphql_variables: JSON.stringify({ paymentProviderId })
        });

        if (listSubsResponse.errors) throw listSubsResponse.errors.map(e => e.message);

        const subscriptions = listSubsResponse.data.listUserSubscriptions;
        const subscriptionWithSelectedPaymentMethods = subscriptions.find(sub => tokenIds.includes(sub.paymentMethod?.token) && sub.auto_pay);

        if (subscriptionWithSelectedPaymentMethods) {
          const accountId = subscriptionWithSelectedPaymentMethods.account_id;
          let errorMessage = 'Payment method(s) used for recurring payments';
          if (accountId) {
            errorMessage += ` on account AC-${accountId}`;
          }
          
          throw new Error(errorMessage);
        }

        // Delete tokens from GPI & wp_usermeta
        await sendAjaxUserMicro(ajaxCall, {
          tokens: tokenIds,
          paymentProviderId,
        }, 'delete');

        // Remove credit cards or bank accounts from AWS Cognito ID token
        var form = $(formSelector);

        // enable spinner animation on submit button
        $('.button-spinner', form).prop('disabled', true);

        // clear form message
        $('.form-card-message', form).empty().removeClass('form-card-message-success form-card-message-error');
      } catch (error) {
        $('.button-spinner', this).prop('disabled', false);
        $('.form-card-message', this).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(error);
      }
    } else {
      $('.button-spinner', this).prop('disabled', false);
      $('.form-card-message', this).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Please select a source to delete.');
    }
  });
}

function setupBankAccountDeletionForm() {
  return setupAccountDeletionForm('#delete-gpi-bank-accounts', '#chirp-delete-gpi-bank-account-nonce', 'delete-bank-accounts');
}

function setupCardDeletionForm() {
  return setupAccountDeletionForm('#delete-gpi-credit-cards', '#chirp-delete-gpi-payment-nonce', 'delete-cards')
}

async function setupGPICardForm(refreshAccounts) {
  const gpiApiKey = $('meta[name="gpi-tokenization-api-key"]').attr('content');
  const gpiEnvironment = $('meta[name="gpi-environment"]').attr('content');

  return new PaymentAccountForm({
    accountFormEventEmitter: new GpiCardFormEventEmitter({
      'X-GP-Api-Key': gpiApiKey,
      'X-GP-Environment': gpiEnvironment,
      'enableAutocomplete': true
    }, GPIForm),
    accountFormValidator: new GpiCardFormValidator({
      nonce: $('#chirp-add-gpi-payment-nonce'),
      street: $('#gpi-street-address'),
      zip: $('#gpi-zip-code')
    }),
    spinner: $('#add-gpi-payment .free-spinner'),
    formMessage: $('#add-gpi-payment .form-card-message'),
    refreshAccounts: refreshAccounts
  }).initialize();
}

async function setupGPIBankAccountForm(refreshAccounts) {
  return new PaymentAccountForm({
    accountFormEventEmitter: new GpiBankAccountEventEmitter('#add-gpi-bank-account'),
    accountFormValidator: new GpiBankAccountFormValidator({
      nonce: $('#chirp-add-gpi-bank-account-nonce'),
      accountNumber: $('#bank-account-number-gpi'),
      routingNumber: $('#bank-routing-number-gpi'),
      accountType: $('#bank-account-type-gpi'),
      firstName: $('#bank-account-first-name-gpi'),
      lastName: $('#bank-account-last-name-gpi'),
      businessName: $('#bank-account-business-name-gpi'),
    }),
    spinner: $('#add-gpi-bank-account .free-spinner'),
    formMessage: $('#add-gpi-bank-account .form-card-message'),
    refreshAccounts
  }).initialize();
}

const gpiErrorCodes = [
	'processing_forbidden', 'invalid_input', 'invalid_card', 'server_error', 'authentication_failed', 'invalid_payment_token', 'invalid_temporary_token', 'invalid_transaction_referenced', 'service_unavailable', 'server_busy'
];

const PaymentProvidersById = Object.freeze({
	GPI: 1,
	SlidePay: 2,
});

class PaymentProviderError extends Error {
	code;
	paymentProviderId;
	category;
	subcategory;
	retryable;
	opsIssue;
	rawMessage;
	notifyUser;

	constructor(
		code,
		message,
		paymentProviderId = PaymentProvidersById.GPI,
		metadata = {},
	) {
		super(message);
		this.code = code;
		this.paymentProviderId = paymentProviderId;
		this.category = metadata.category;
		this.subcategory = metadata.subcategory;
		this.retryable = metadata.retryable;
		this.notifyUser = metadata.notifyUser;
		this.opsIssue = metadata.opsIssue;
		this.rawMessage = metadata.rawMessage;
	}

	get shouldNotifyUser() {
		if (this.notifyUser !== undefined) {
			return this.notifyUser;
		}

		return (
			this.code === 'invalid_input' ||
			this.message === 'Payment Declined' ||
			this.paymentProviderId === PaymentProvidersById.SlidePay
		);
	}
}

const isValidGPIErrorResponse = (response) => {
	return 'error' in response && 'code' in response.error && gpiErrorCodes.includes(response?.error?.code);
};

const isValidGPIDeclineError = (response) => {
	return 'status' in response && 'processor_response' in response;
};

const createGPIError = ({
	rawError,
	code,
	clientType,
	notifyUser = false,
	defaultErrorMessage,
}) => {
	let message;
	let isDeclineError = false;
	let isKnownDecline = false;
	const defaultPaymentErrorMessage =
		'Payment could not be processed. Please try again later or use a different payment method.';
	const defaultRefundErrorMessage = 'Refund could not be processed. Please try again later.';
	const defaultTokenizerErrorMessage =
		'Request could not be processed. Please try again later or use a different payment method.';
	if (!defaultErrorMessage) {
		defaultErrorMessage =
			clientType === 'PAYMENT'
				? defaultPaymentErrorMessage
				: clientType === 'REFUND'
					? defaultRefundErrorMessage
					: defaultTokenizerErrorMessage;
	}
	const defaultDeclineErrorMessage = 'Payment declined. Please try again or use a different payment method.';

	try {
		const parsedError = typeof rawError === 'string' ? JSON.parse(rawError) : rawError;
		if (isValidGPIErrorResponse(parsedError)) {
			message = getCustomGPIErrorMessage(parsedError);
		} else if (isValidGPIDeclineError(parsedError)) {
			const mappedDeclineMessage = getCustomDeclineErrorMessage(parsedError);
			isKnownDecline = Boolean(mappedDeclineMessage);
			message = mappedDeclineMessage || defaultDeclineErrorMessage;
			isDeclineError = true;
		} else {
			message = defaultErrorMessage;
		}
	} catch {
		message = defaultErrorMessage;
	}

	return new PaymentProviderError(code, message, PaymentProvidersById.GPI, {
		category: isDeclineError ? 'PAYMENT_DECLINE' : 'PROVIDER_ERROR',
		subcategory: isDeclineError
			? isKnownDecline
				? 'KNOWN_DECLINE'
				: 'UNSPECIFIED_DECLINE'
			: 'UNMAPPED_PROVIDER_ERROR',
		retryable: Number(code) >= 500,
		notifyUser,
		rawMessage: typeof rawError === 'string' ? rawError : JSON.stringify(rawError),
	});
};

const customErrorMessages = {
	authentication_failed: 'Server error. Please contact support.',
	invalid_card: 'Invalid card number. Please check your card details and try again or use a different payment method.',
	'/payment/amount': 'Amount should be greater than zero.',
	'/card/temporary_token':
		'Invalid input data. Please check your card details and try again or use a different payment method.',
	'/card/card_security_code': 'Invalid Security Code (CVV). Please check your card details and try again or use a different payment method.',
	'/card/card_expiration_date': 'Invalid Expiration Date. Please check your card details and try again or use a different payment method.',
	'/card/card_number': 'Invalid Card Number. Please check your card details and try again or use a different payment method.',
	'/card/expiry_year': 'Invalid Expiration Date. Please check your card details and try again or use a different payment method.',
	'/card/expiry_month': 'Invalid Expiration Date. Please check your card details and try again or use a different payment method.',
	'/customer/billing_address/line1': 'Invalid Billing Address',
	'/customer/billing_address/postal_code': 'Invalid Postal Code',
	'/customer/first_name': 'Invalid First Name',
	'/customer/last_name': 'Invalid Last Name',
	invalid_payment_token: 'Invalid payment token. Please retry with valid token or use different payment method.',
	invalid_temporary_token:
		'Invalid temporary token. Please retry with valid temporary_token or use different payment method.',
	invalid_transaction_referenced: 'Duplicate reference_id sent.',
	processing_forbidden:
		'This transaction has already been processed. Please check your transaction history before trying again.',
	server_error: 'Server error. Please contact support.',
	server_busy: 'Server is busy. Please retry the request.',
	service_unavailable: 'Service temporarily unavailable, Please try later or contact support',
	'/customer/business_name': 'Maximum Business Name length is 50 characters. Please check your business name and try again.',
};

function getCustomGPIErrorMessage(gpiError) {
	const detailPaths = gpiError.error.detail?.map((d) => d.data_path) ?? [];
	const fallbackMessage = 'Server error. Please contact support.';

	let customMessage = undefined;
	for (const dataPath of detailPaths) {
		const detailMessage = customErrorMessages[dataPath];

		if (!detailMessage) {
			continue;
		}

		if (customMessage !== undefined) {
			customMessage += `; ${detailMessage}`;
		} else {
			customMessage = detailMessage;
		}
	}

	return customMessage ?? customErrorMessages[gpiError.error.code] ?? fallbackMessage;
}

const customDeclineErrorMessages = {
	'003INVLD MERCH ID': 'Card declined. Please try again or use a different payment method.',
	'004DECLINE DO NOT RETRY': 'Card reported lost or stolen. Please use a different payment method.',
	'004PIC UP': 'Card reported lost or stolen. Please use a different payment method.',
	'005ADDTNL AUTHN REQD': 'Additional Authentication Required. Please try again or use a different payment method.',
	'005DECLINE': 'Card declined. Please check your card details and try again or use a different payment method.',
	'005DECLINE TRY LATER': 'Card declined. Please call your bank or use a different payment method.',
	'005DO NOT TRY AGAIN': 'Card declined. Please call your bank or use a different payment method.',
	'007DECLINE-CV2 FAIL':
		'Security code (CVV) check failed. Please check your card details and try again or use a different payment method.',
	'014DECLINE DO NOT RETRY':
		'Incorrect card number. Please check your card details and try again or use a different payment method.',
	'014INVLD ACCT':
		'Incorrect card number. Please check your card details and try again or use a different payment method.',
	'015DECLINE DO NOT RETRY':
		'Incorrect card number. Please check your card details and try again or use a different payment method.',
	'046CLOSED ACCOUNT': 'Closed Account. Please use a different payment method.',
	'046DECLINE DO NOT RETRY': 'Closed Account. Please use a different payment method.',
	'051DECLINE RETRY LATER': 'Insufficient funds. Please use a different payment method.',
	'051RETRY AFTER 1 HOUR': 'Insufficient funds. Please use a different payment method.',
	'051RETRY AFTER 10 DAYS': 'Insufficient funds. Please use a different payment method.',
	'051RETRY AFTER 24 HOURS': 'Insufficient funds. Please use a different payment method.',
	'054INVLD EXP DATE':
		'Invalid Expiration Date or Expired Card. Please check the expiration date or use a different payment method.',
	'057TRAN NOT ALLOWED': 'The card issuer does not allow this type of transaction. Please use a different payment method.',
	'059DECLINE RETRY LATER': 'Card declined. Please try again later or use a different payment method.',
	'05CDECLINE RETRY LATER': 'Card declined. Please try again later or use a different payment method.',
	'062DECLINE RETRY LATER': 'Restricted card. Please use a different payment method.',
	'065DECLINE RETRY LATER': 'Card has exceeded withdrawal limit. Please use a different payment method.',
	'072ACCT NOT ACTIVATED': 'Account not activated. Please contact your bank or use a different payment method.',
	'075DECLINE RETRY LATER': 'Card declined. Too many incorrect PIN entries. Please try again later or use a different payment method.',
	'078DECLINE RETRY LATER': 'Card not activated. Please contact your bank or use a different payment method.',
	'091DECLINE RETRY LATER': 'Card issuer unavailable. Please try again later or use a different payment method.',
	'09GDECLINE RETRY LATER': 'Card soft declined for security hold, unusual purchase location or exceeded daily limit. Please try again later or use a different payment method.',
	'121LIMIT EXCEEDED': 'Card has exceeded withdrawal limit. Please use a different payment method.',
};

const getCustomDeclineErrorMessage = (rawError) => {
	return customDeclineErrorMessages[rawError.processor_response];
};
